module.exports = __webpack_public_path__ + "img/xymoxSmall.a5cc3dd9.jpg";